import React from "react";
import styled from "styled-components";

import LOGO_PATH from "../../assets/logos/Iris-Logo-Web_Full Color.png";

import { escapeHTML } from "../../utils";

const StyledContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .image {
    width: 200px;
    height: 200px;
    object-fit: contain;
    object-position: center;
    margin-bottom: 20px;
  }
  h1,
  p {
    text-align: left;
    padding: 0 2rem;
  }
`;
const Maintenance = () => (
  <StyledContainer>
    <img src={LOGO_PATH} className="image animated fadeIn slow" alt="logo" />
    <div className="animated fadeIn slow">
      <h1>{escapeHTML("Sorry we're down for maintenance")}</h1>
      <p>Please check back later</p>
    </div>
  </StyledContainer>
);

export default Maintenance;
